<div class="flex justify-content-center align-items-center h-full">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.66731 0.833496L4.16731 15.8335M13.334 0.833496L10.834 15.8335M15.834 5.00016H1.66732M15.0007 11.6668H0.833984" [attr.stroke]="stroke()" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
